module.exports = {
      id: "icon-finger-usage",
      viewBox: "0 0 274 274",
      url: "/" + "sprite.svg#icon-finger-usage",
      toString: function () {
        return this.url;
      }
    }